// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-zCHoKc","body":"body-no3lEu"};